import { Button, Card, Form, InputNumber } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { buttonLabel, cardConfig, formConfig } from '../../../../constants';
import { useEffect, useState } from 'react';
import { getSubsidiaries, updateConfigs } from '../../../../appRedux/actions';
import { useCustomModal } from '../../../../hooks/useCustomModal';

export const SettingsExchangeRateModal = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const { subsidiaries } = useSelector((state) => state.subsidiary);
  const { configs } = useSelector((state) => state.configs);
  const [form] = Form.useForm();
  const { setShowModal } = useCustomModal();
  const [isLoading, setIsLoading] = useState(false);
  const [configId, setConfigId] = useState();
  const [response, setResponse] = useState();

  useEffect(() => {
    setConfigId(configs?.id);
  }, [configs?.id]);

  useEffect(() => {
    if ([200, 201].includes(response)) {
      setShowModal(false);
      if (onSuccess) {
        onSuccess();
      }
    }
  }, [response, setShowModal, onSuccess]);

  useEffect(() => {
    dispatch(getSubsidiaries());
  }, [dispatch]);

  useEffect(() => {
    if (subsidiaries?.length) {
      const initialRates = {};

      subsidiaries.forEach((sub) => {
        if (
          configs?.exchangeRate &&
          configs.exchangeRate[sub.id] !== undefined
        ) {
          initialRates[sub.id] = configs.exchangeRate[sub.id];
        } else {
          initialRates[sub.id] = 0;
        }
      });

      form.setFieldsValue({ exchangeRate: initialRates });
    }
  }, [subsidiaries, configs, form]);

  const onSubmit = async (values) => {
    setIsLoading(true);
    if (configId) {
      setResponse(await dispatch(updateConfigs(configId, values)));
    }
    setIsLoading(false);
  };

  return (
    <Card size="small" bordered={true} style={cardConfig}>
      <Form autoComplete="off" onFinish={onSubmit} form={form} {...formConfig}>
        {subsidiaries?.map((sub) => (
          <Form.Item
            key={sub.id}
            name={['exchangeRate', sub.id]}
            label={sub.name}
            rules={[
              { required: true, message: 'Debe ingresar un tipo de cambio' },
              { type: 'number', min: 0, message: 'Debe ser mayor que  0' },
            ]}
          >
            <InputNumber
              min={0}
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, '')}
              style={{ width: '100%' }}
            />
          </Form.Item>
        ))}

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="btn-form"
            loading={isLoading}
          >
            {buttonLabel.save}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};
